export { default } from './JournalFeed'
